import { useContext, useEffect, useState } from 'react';
import { basePath } from '../Constants/constant';
import { ToastContainer, Bounce } from 'react-toastify';
import { AppContext } from '../ContextApi/ContextApi';
import BasicButton from "../Usables/Buttons";
import axios from 'axios';
import RecruiterSummaryReport from './RecruiterSummaryReport';
import RecruiterPositionWiseReport from './RecruiterPositionWiseReport';

function ReportAndAnalysis(props) {
    const { setIsModalOpen, apiHeaderJSON } = useContext(AppContext);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [reportType, setReportType] = useState('1');

    const getUserData = async () => {
        let options = {
            headers:apiHeaderJSON
        }
        let response = await axios.get(`${basePath}/getRecruiter`, options);
        // console.log(response.data);
        const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        const listFilter = response?.data?.filter((val)=>{
            if(val?.activated === 1) return  val;
        });
        const activeList = listFilter?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        setAllUsers(recruiterList);
        setUsersOption(activeList);
    };
   
    useEffect(() => {
        getUserData();
    }, []);


    return (
        <section onClick={() => { setIsModalOpen(false); }} className='lightBabyGreen customScroll mb-5'>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <div className='welcomeBarHeight babyGreen smoothTransition textDarkPurple px-10 rounded-3xl flex items-center justify-between navAnimation  m-auto'>
                <div className=' text-left'>
                    <h1 className=' text-5xl font-bold'>Report And Analysis</h1>
                    <p className=' text-gray-500 font-semibold'>Ready to start your day</p>
                </div>
                <img className=' w-44' src="/img/registration.png" alt="registration" />
            </div>
            <div className="space-y-4 mt-5">
                <div className="flex justify-end items-center">
                  
                    <BasicButton
                        onClick={() => setReportType(prev => (prev === '1' ? '2' : '1'))}
                        buttonName={reportType === '1' ? 'Switch to Summary Report' : 'Switch to Position-wise Report'} className="darkPurple text-nowrap" shadow={true}
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen"
                    />
                      
                </div>
                {reportType === '1' ? 
                    <RecruiterPositionWiseReport allUsers = {allUsers} usersOption = {usersOption} setUsersOption = {setUsersOption} /> :
                    <RecruiterSummaryReport allUsers = {allUsers} usersOption = {usersOption} />
                }
            </div>
           
            
        </section>
    );
}

export default ReportAndAnalysis;